import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import { Collapse, Button, CardBody, Card, CardTitle } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"

import api from "../../../../api";
import auth from "../../../../auth";
import functions from "../../../../functions";


const Carrito = (props) => {
     const [isOpen, setIsOpen] = useState(false);
     const toggle = () => setIsOpen(!isOpen);
     const item = props.item;
     const token = auth.token();
     const establecercarritodefecto = (token, idcarrito) => {
          toggle();
          if(token != '' && idcarrito > 0){
               axios.post(
                    api.gestion.ventas.establecercarrito,
                    { id_carrito : idcarrito },
                    { headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` } },
               ).then(
                    res=>props.callback && props.callback(true)
               ).catch(
                    err=>props.callback && props.callback(false)
               );
          }
     }
     return (
          <Card key={"panel-"+props.index} className="rounded border-secondary">
               <CardBody className="p-1">
                    <CardTitle className="p-0" onClick={toggle}>
                         <div className="row">
                              <div className="col">
                                   Carrito al {functions.DateTimeFormatter(item.Fecha)}
                              </div>
                              <div className="col text-right">
                                   <span className={isOpen==true?"fa fa-arrow-up":"fa fa-arrow-down"}></span>
                              </div>
                         </div>
                    </CardTitle>
                    <Collapse isOpen={isOpen}>
                    <div className="row">
                         {
                              item.Carrito.length == 0 ?
                              <div className="col-12">Carrito Vacio</div>
                              :
                              <ul className="col-12">
                                   {
                                        item.Carrito.map(
                                             (art, indx)=> <li className="list-unstyled" key={'art-'+indx}>{`(${art.Codigo}) ${art.Titulo} - Cantidad: ${art.Cantidad}`}</li>
                                        )
                                   }
                              </ul>
                         }
                    </div>
                    <Button className="col-12" outline color="primary" onClick={()=> establecercarritodefecto(token, item.id)}>Establecer como actual</Button>
                    </Collapse>
               </CardBody>
          </Card>
     )
};

class ModalCarrito extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id: null,
               carritos:[],
               Nombre:"",
               postVariables: [],
               errors: [],
          };
     }

     static propTypes = {
          onSubmit: PropTypes.func,
          id: PropTypes.func,
          action: PropTypes.oneOf(['EDIT']).isRequired,
     }

     resetForm() {
          this.setState({
               id: null,
               carritos:[],
               Nombre:"",
               errors: [],
          });
     }

     getData() {
          const { postVariables } = this.state;
          let data = {};
          postVariables.forEach(x => {
               data[x] = this.state[x];
          });
          return data;
     }

     setData(data) {
          if (data.success) {
               this.setState({
                    id: data.id,
                    carritos:data.carritos,
                    Nombre:data.Nombre,
               })
          }
     }

     setErrors(errors) {
          this.setState({
               errors: errors,
          });
     }

     refreshData(){
          const token = auth.token();
          if(this.state.id > 0){
               axios.get(
                    `${api.gestion.ventas.clientes}${this.state.id}/`,
                    { headers: { 'Content-Type': 'application/json', 'Authorization': `Token ${token}` } },
               ).then(
                    res=>{
                         if(res.data && res.data.meta && res.data.meta.allowed == true){
                              let data = res.data.data;
                              data.success = true;
                              this.setData(data);
                         }
                    }
               );
          }
     }

     onChangeField(field, value) {
          this.setState(prevState => {
               let errors = prevState.errors;
               if (errors) errors[field] = null;
               prevState.errors = errors;
               prevState[field] = value;
               return prevState;
          });
     }

     getError(field) {
          let errors = this.state.errors;
          if (errors) return errors[field];
          else return null;
     }

     modalVars() {
          const { action } = this.props;
          if (action == "EDIT") {
               return {
                    get: true,
                    submitType: "PATCH",
                    title: "Editar Carritos",
                    buttonTitle: "Editar",
                    danger: false,
                    buttonIcon: "fa fa-shopping-cart fa-lg",
                    successMessage: "",
                    saveButton: false,
                    saveButtonLabel: "Cerrar",
                    buttonClass: "",
                    disabled: false,
                    id: this.props.id,
               };
          };
     }

     render() {
          let vars = this.modalVars();
          const {carritos, Nombre} = this.state;
          if (Nombre != '') vars.title = `Historia de carritos de ${Nombre}`;
          return (
               <ParadigmaModal
                    getUrl={(vars.get ? api.gestion.ventas.carritoCliente : null)}
                    submitUrl={(null)}
                    submitType={vars.submitType}
                    id={vars.id}
                    className={carritos.length == 0 ? "modal-md" : "modal-lg"}
                    onGotData={(data) => this.setData(data)}
                    onGotErrors={(errors) => this.setErrors(errors)}
                    onSubmit={(e) => {}}
                    onClose={() => this.resetForm()}
                    onPreSubmit={() => {}}

                    title={vars.title}

                    danger={vars.danger}
                    buttonClass={vars.buttonClass}

                    successMessage={vars.successMessage}
                    missingIdMessage={"Debe seleccionar una fila."}
                    saveButtonLabel={vars.saveButtonLabel}
                    buttonTitle={vars.buttonTitle}
                    buttonIcon={vars.buttonIcon}
                    saveButton={vars.saveButton}
                    closeButton={true}
                    >
                         {
                              carritos.length == 0 && <div className="text-center">No posee carritos asociados</div>
                         }
                         {
                              carritos.length > 0 && Nombre != '' &&
                              carritos.map(
                                   (item,index) =>{
                                        const i = index;
                                        return (
                                             <Carrito item={item} callback={(result)=> result==true && this.refreshData()} index={index} />
                                        )
                                   }
                              )
                         }
                    </ParadigmaModal>
               );
          }
     }

     export default ModalCarrito;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Clientes/ModalCarrito.js